import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import classes from './FormTextarea.scss'

import FormLabel from '../Label'

export const FormTextarea = (props) => {
  let className = { [classes['textarea']]: classes['textarea'] }
  props.options.forEach((option) => {
    className[classes[`textarea--${option}`]] = classes[`textarea--${option}`]
  })
  className = cx(className)

  return (
    <FormLabel {...props}>
      <textarea
        className={className}

        value={props.value || ''}
        placeholder={props.placeholder || ''}

        {...props.input}
        maxLength={props.maxLength}
        onChange={props.onChange && ::props.onChange}
      />
    </FormLabel>
  )
}

FormTextarea.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  input: PropTypes.shape({}),

  options: PropTypes.array
}

FormTextarea.defaultProps = {
  options: ['block']
}

export default FormTextarea



// WEBPACK FOOTER //
// ./src/components/Form/Textarea/FormTextarea.js